import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { translatePT } from "./i18n/locales/translatePT";
import { translateEN } from "./i18n/locales/translateEN";
import { translateES } from "./i18n/locales/translateES";
import { translateFR } from "./i18n/locales/translateFR";

i18n.use(LanguageDetector).init({
  resources: {
    en: { translations: translateEN },
    pt: { translations: translatePT },
    es: { translations: translateES },
    fr: { translations: translateFR },
  },
  fallbackLng: "en",
  ns: ["translations"],
  defaultNS: "translations",
  supportedLngs: ["en", "pt", "es", "fr"],
  debug: process.env.REACT_APP_I18N_LOGGER === "true",
  interpolation: { escapeValue: false, formatSeparator: "," },
  detection: {
    order: ["localStorage", "navigator", "htmlTag"],
    caches: ["localStorage"],
  },
});

export default i18n;
